import { putData } from "./api";
// import { postData } from "../../services/api";

export const loginUser = async ({ email, password }) => {
  try {
    const payload = { email, password };
    const response = await putData("/user/login", payload);
    console.log("Full response:", response);
    console.log("Response data:", response.token);
    if (response.token) {
      return {
        status: "ok",
        data: response.token,
      };
    }
    return {
      status: 0,
      message: "Invalid credentials. Please try again.",
    };
  } catch (error) {
    return {
      status: 0,
      message: error.response.data.error,
    };
  }
};

export const logoutUser = () => {
  // clear tokens, session, etc.
};

export const getCurrentUser = () => {
  // check localStorage / cookie
  return null;
};
